// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper","disabled":"Checkbox_disabled","checkbox":"Checkbox_checkbox","checked":"Checkbox_checked","label":"Checkbox_label"};